import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_TVCHANNELS,
} from '../../../../../constants/RoleConsts';
import {
  TVCHANNEL_CHANNELS_EDIT,
  TVCHANNEL_CHANNEL_TABS,
} from '../../../../../constants/TvChannelsConst';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { bouquetSelector, channelSelector } from '../../../cmsSlice';
import ChannelDetails from './Channel-Details';

const ChannelView = (props) => {
  const { channel, hotelId, toggleDrawer, onViewToggle, permissions } = props;
  const [tabValue, setTabValue] = useState(0);
  const [selectedChannel, setSelectedChannel] = useState(channel);
  const bouquetListData = useSelector(bouquetSelector);
  const channelList = useSelector(channelSelector);

  useEffect(() => {
    const channelDetails = async () => {
      if (channel && channelList.length) {
        const channelObj = {
          ...channelList.find((tempChannelInfo) => tempChannelInfo.id === channel.id),
        };
        const channelData = channelObj;
        let bouquetList = [];
        bouquetList = channel.bouquet.map((item) => {
          const data = bouquetListData.find((bouquetItem) =>
            bouquetItem.id === item.id ? bouquetItem?.name : null,
          );
          return { ...item, name: data ? data.id : null };
        });
        channelData.bouquetNames = bouquetList;
        setSelectedChannel(channelData);
      }
    };
    channelDetails();
  }, [channel, channel.id, bouquetListData, channelList]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, selectedChannel);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(TVCHANNEL_CHANNELS_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <ChannelDetails tabValue={tabValue} channel={selectedChannel} />;
  };

  return (
    <>
      {selectedChannel && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={TVCHANNEL_CHANNEL_TABS}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          createdUserId={selectedChannel.createdBy}
          isEditable={permissions[RBAC_TYPE_CMS_TVCHANNELS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          isHeightIncluded={true}
          title={selectedChannel.name}
          tabClass='col-md-3'
        />
      )}
    </>
  );
};

export default ChannelView;
